import React, { ChangeEvent, FC } from 'react';
import { Label, Checkbox } from 'evergreen-ui';

import { Interest, InterestsBlock } from 'src/domain/interest';

type InterestsBlocksProps = {
	blocks: InterestsBlock[];
	interests: Interest[];
	onChange: (payload: { interest: Interest; checked: boolean }) => void;
}

export const InterestsBlocks: FC<InterestsBlocksProps> = (props) => {
	const { blocks, onChange, interests } = props;

	return (
		<>
			{blocks.map(item => (
				<div>
					<Label>{item.title}</Label>
					{item.interests.map(interest => (
						<Checkbox
							label={interest.name}
							checked={interests.find(item => item.id === interest.id) !== undefined}
							onChange={(e: ChangeEvent<HTMLInputElement>) => onChange({ interest, checked: e.target.checked })}
						/>
					))}
				</div>
			))}
		</>
	);
};
